import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as signalR from "@aspnet/signalr";
import { API_BASE_URL } from '@shared/service-proxies/service-proxies';

@Injectable({
    providedIn: 'root'
})
export class SignalRService {
    private wmsUrl: string;
    private wmsHubConnection: signalR.HubConnection
    private onlineUserUrl: string;
    private onlineUserHubConnection: signalR.HubConnection
    private controlPointListSubject = new BehaviorSubject(null);
    public controlPoint$ = this.controlPointListSubject.asObservable();
    private syncListSubject = new BehaviorSubject(null);
    public syncUpdate$ = this.syncListSubject.asObservable();
    constructor(@Inject(API_BASE_URL) baseUrl: string) {
        this.wmsUrl = baseUrl + "/wmshub"
        this.onlineUserUrl = baseUrl + "/onlineuserhub"
    }

    public initWmsHub = () => {
        this.wmsHubConnection = new signalR.HubConnectionBuilder()
            .withUrl(this.wmsUrl)
            .build();
        this.wmsHubConnection
            .start()
            .then(() => console.log('Connection started'))
            .catch(err => console.log('Error while starting connection: ' + err));

    }
    public initOnlineUserHub = () => {
        this.onlineUserHubConnection = new signalR.HubConnectionBuilder()
            .withUrl(this.onlineUserUrl)
            .build();
        this.onlineUserHubConnection
            .start()
            .then(() => console.log('Connection started'))
            .catch(err => console.log('Error while starting connection: ' + err));
    }
    public controlPointRefresh = () => {
        this.wmsHubConnection.on("controlPointRefresh", () => {
            this.controlPointListSubject.next(null);
        });
    }
    public updateSync = () => {
        this.wmsHubConnection.on("updateSync", () => {
            this.syncListSubject.next(null);
        });
    }
    public onlineUsers = () => {
        this.onlineUserHubConnection.on("onlineUserChanged", (users) => {
            abp.event.trigger("wms.onlineusers.received", (users));
        });
    }
}
